import { useEffect, useState } from "react";
import { IconMusic } from "@tabler/icons-react";

interface SongArtProps {
  coverArt: string | null;
}

/**
 * Small square album thumbnail for a song row. Falls back to a music-note
 * placeholder when no cover URL is available or the image fails to load
 * (Cover Art Archive often 404s for obscure recordings). The art is purely
 * decorative — the title/artist text carries the meaning — so it has no alt.
 */
export const SongArt = ({ coverArt }: SongArtProps) => {
  const [failed, setFailed] = useState(false);

  // A new song row reuses this component instance, so reset on URL change.
  useEffect(() => {
    setFailed(false);
  }, [coverArt]);

  if (!coverArt || failed) {
    return (
      <span className="dj-art placeholder" aria-hidden="true">
        <IconMusic />
      </span>
    );
  }

  return (
    <img
      className="dj-art"
      src={coverArt}
      alt=""
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
};
